import React, { useEffect } from 'react';
import { SEO } from '../components/SEO';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
export function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-[#FAFAFA] font-sans selection:bg-kitty-yellow-200 selection:text-kitty-dark" data-id="element-577" data-mp="qbcxkdc16hs1">
      <SEO title="Privacy Policy | KittyPot" description="How KittyPot, a shared expense and settlement tracker, collects and protects your data. The current MVP covers expense tracking and manual settlement only; KittyPot does not hold or move money." ogTitle="KittyPot Privacy Policy" ogDescription="How KittyPot handles your data as a shared expense and settlement tracker." path="/privacy-policy" data-id="element-578" data-mp="mbuc9ggas4oo" />
      <Navbar data-id="element-579" data-mp="156j2ewze4ajs" />
      <main className="pt-32 pb-24" data-id="element-580" data-mp="21pzyk56qd9wc">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-581" data-mp="21r1mha8uhqvh">
          <h1 className="text-4xl font-black text-kitty-dark mb-6" data-id="element-582" data-mp="1wz00uxpsenss">
            Privacy Policy
          </h1>
          <div className="prose prose-gray max-w-none text-gray-600 space-y-6" data-id="element-583" data-mp="50rbr86xfcra">
            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-584" data-mp="9zujx1i7dz3h">
              General
            </h2>
            <p data-id="element-585" data-mp="3rh59ieriybzq">
              KittyPot is a shared expense and settlement tracking app. Your
              privacy is important to us. It is KittyPot Ltd.'s policy to
              respect your privacy regarding any information we may collect from
              you across our website, https://www.kittypot.com, and any other
              sites or services we own and operate.
            </p>
            <p data-id="element-586" data-mp="38i9itdevkfqn">
              <strong data-id="element-587" data-mp="38it2ozo35e7b">Data we may collect:</strong> We may collect account
              information, waitlist/contact form data, expense entries,
              kitty/member information, manual settlement statuses, guest/local
              data (where applicable), and device/local storage data. If you
              allow contacts, we only check whether someone you already know is
              on KittyPot. We do not upload your whole address book, and we do
              not let anyone browse a list of all users. We also use analytics
              and cookies on our website.
            </p>

            <p data-id="element-588" data-mp="10b60lfhgo1q4">
              We only collect personal information where it is genuinely
              necessary to provide our services. We collect information by fair
              and lawful means, with your knowledge and consent, and we clearly
              explain why it is being collected and how it will be used.
            </p>

            <p data-id="element-589" data-mp="1o1s9ta37bs1p">
              We retain personal information only for as long as necessary to
              deliver the service you have requested. Any data we store is
              protected using commercially reasonable measures to prevent loss,
              theft, unauthorised access, disclosure, copying, use, or
              modification.
            </p>

            <p data-id="element-590" data-mp="26xib0v3b8kej">
              We do not share personally identifiable information publicly or
              with third parties, except where required to do so by law or where
              necessary to provide our services.
            </p>

            <p data-id="element-591" data-mp="3umig6xgpkmnc">
              You may request the deletion of your personal data at any time,
              and we will securely erase it in accordance with applicable data
              protection laws.
            </p>

            <p data-id="element-592" data-mp="cf1ayph7g88i">
              Our website may contain links to external websites that are not
              operated by us. Please note that we have no control over the
              content or practices of these sites and cannot accept
              responsibility or liability for their respective privacy policies.
            </p>

            <p data-id="element-593" data-mp="q54rr0xbf9qk">
              You are free to decline our request for personal information,
              however this may mean we are unable to provide certain services.
            </p>

            <p data-id="element-594" data-mp="103klzcrn2z4a">
              Your continued use of our website will be regarded as acceptance
              of our privacy practices. If you have any questions about how we
              handle user data and personal information, please contact us at
              support@kittypot.com.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-595" data-mp="w6esgp8zq95f">
              Sign-Up & Contact
            </h2>
            <p data-id="element-596" data-mp="r8vfrtrxy4fl">
              You can join our waitlist or contact us via the contact form on
              our website. If you have any questions or require assistance,
              we're always happy to help.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-597" data-mp="3urgdc5tav7uc">
              Cookie Policy
            </h2>
            <p data-id="element-598" data-mp="8i5fmctr8vqf">
              Cookies are small text files placed on your device by a website's
              server. They help websites function properly, remember user
              preferences, and improve the overall user experience.
            </p>

            <p data-id="element-599" data-mp="1jwrbow9orsbb">We use cookies for the following purposes:</p>
            <ul className="list-none space-y-4" data-id="element-600" data-mp="1rga947jofo3f">
              <li data-id="element-601" data-mp="1rimrumx9e2hj">
                <strong data-id="element-602" data-mp="1wfmu0mqzml3d">a) Identification</strong> — Cookies help us recognise
                your device so you don't need to re-enter information repeatedly
                when navigating between pages.
              </li>
              <li data-id="element-603" data-mp="1mgp0t6ima3e1">
                <strong data-id="element-604" data-mp="1mi8i90g0ekhe">b) Analytics</strong> — Cookies help us understand how
                visitors use our website, such as which pages are viewed and how
                often, so we can improve performance and usability.
              </li>
            </ul>

            <p data-id="element-605" data-mp="21ezg35a1bo4w">
              You can choose to disable cookies through your browser settings.
              Please note that disabling cookies may limit certain functionality
              of the website.
            </p>
          </div>
        </div>
      </main>
      <Footer data-id="element-606" data-mp="2t3svx1wiyzdy" />
    </div>;
}